define((require) => {
    "use strict";

    const AbstractWidgetPropertiesView  = require("ui/experience/widgets/AbstractWidgetPropertiesView");
    const SizeAndPositionPropertiesView = require("ui/experience/widgets/SizeAndPositionPropertiesView");
    const template                      = require("ui/experience/widgets/MultipleSelectionPropertiesView.tpl");

    /**
     * The properties view for a selection of multiple widgets.
     */
    return AbstractWidgetPropertiesView.extend({

        template,

        regions: {
            sizeAndPositionProperties: ".size-and-position-properties"
        },

        onRender() {
            this.__super();
            this.sizeAndPositionProperties.show(new SizeAndPositionPropertiesView({
                model: this.model,
                editorViewModel: this.viewScope.viewModel,
                shouldExpandOnRender: true,
                hideRotation: true,
                hideSizeControls: true
            }));
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/MultipleSelectionPropertiesView.js